<template>
  <div>
    <NavBar :show-beta-notice="true" />
    <div class="container">
      <div class="row mt-5 mb-5">
        <div class="col-md-6 title">
          <h1>Dashboard</h1>
        </div>
        <div class="col-md-6 text-right">
          <router-link :to="{ name: 'site.create'}" class="btn btn-primary col-md-6">
            New Project
          </router-link>
        </div>
      </div>

      <Errors :errors="errors" />

      <LoadingWrapper :loading-bool="loading">
        <b-card v-for="item in items" :key="item.id" class="mb-3 shadow site">
          <div class="row p-4">
            <div class="col-md-4">
              <h3>{{ item.name }}</h3>
              <p>{{ item.url }}</p>
            </div>
            <div class="offset-md-2 col-md-3">
              <button v-if="item.latest_evaluation_id != null"
                      class="btn btn-primary mb-2"
                      :href="resolve(item, 'evaluation.detail', {evaluationId: item.latest_evaluation_id})"
                      @click="goTo($event, item, 'evaluation.detail', {evaluationId: item.latest_evaluation_id})">
                Show Results
              </button>
            </div>
            <div class="col-md-3">
              <button class="btn btn-primary"
                      :href="resolve(item, 'evaluation.create')"
                      @click="evaluate($event, item)">
                <span v-if="item.pending_evaluation_id != null">Complete Evaluation</span>
                <div v-if="item.pending_evaluation_id == null">
                  <span v-if="item.latest_evaluation_score == null">Evaluate</span>
                  <span v-if="item.latest_evaluation_score != null">Re-Evaluate</span>
                </div>
              </button>
            </div>
          </div>

          <ul class="boxes">
            <li>
              <p class="title">
                Latest Evaluation
              </p>
              <p v-if="item.latest_evaluation_completed_at">
                {{ renderDate(item.latest_evaluation_completed_at) }}
              </p>
              <p v-if="!item.latest_evaluation_completed_at">
                N/A
              </p>
            </li>
            <li>
              <p class="title score">
                Latest Score
              </p>
              <p v-if="item.latest_evaluation_score" class="score">
                {{ item.latest_evaluation_score }}%
              </p>
              <p v-if="!item.latest_evaluation_score" class="score">
                N/A
              </p>
            </li>
            <li>
              <b-dropdown id="dropdown-1" class="edit-dropdown" right no-caret variant="edit">
                <template slot="button-content">
                  <span class="vellip d-none d-md-block">&vellip;</span>
                  <span class="options d-md-none">Options</span>
                </template>
                <b-dropdown-item
                  :href="resolve(item, 'site.edit')"
                  @click="goTo($event, item, 'site.edit')">
                  Edit
                </b-dropdown-item>
                <b-dropdown-item @click="$bvModal.show(`coming-site-delete-${item.id}`)">
                  Delete
                </b-dropdown-item>
              </b-dropdown>
            </li>
          </ul>
          <b-modal :id="`coming-site-delete-${item.id}`" class="mt-5" hide-footer hide-header>
            <div class="d-block text-center">
              <h3>Are you sure?</h3>
              <p>
                Deleting the project "{{ item.name }}" will also delete all the data associated with it.
                You will no
                longer be able to access any reports you've created related to this project and this
                information will be destroyed.
              </p>
              <button class="btn btn-primary mb-2" @click="deleteSite(item.id)">
                Delete
              </button>
              <button class="btn btn-secondary" @click="$bvModal.hide(`coming-site-delete-${item.id}`)">
                Back
              </button>
            </div>
          </b-modal>
        </b-card>

        <b-card v-if="!items.length" class="mb-3 shadow site">
          <div class="row pt-5 pb-4">
            <div class="col text-center">
              <p>Sorry, you don't seem to have any projects. Please create one.</p>
            </div>
          </div>
        </b-card>
      </LoadingWrapper>
      <Footer />
    </div>
  </div>
</template>


<style lang="scss" scoped>

    .title {
        @media (max-width: 767px) {
            text-align: center;
            margin-bottom: 2em;
        }
    }

    .site {
        position: relative;
        width: 100%;

        ::v-deep .card-body {
            padding: 0;
        }

        ::v-deep .vellip {
            font-size: 1.3em;
            font-weight: bold;
        }

        .edit-dropdown {

            ::v-deep .btn-edit {

                &:focus {
                    box-shadow: none;
                }
            }
        }

        ul.boxes {
            margin: 0;
            padding: 0;
            width: 100%;
            border-top: rgba(#ddd, 0.6) solid 1.5px;

            > li {
                list-style: none;
                position: relative;
                padding: .5em 1.5em;
                margin: 0;
                text-align: center;
                border-bottom: rgba(#ddd, 0.6) solid 1.5px;

                @media (min-width: 768px) {
                    display: inline-block;
                    border-right: rgba(#ddd, 0.6) solid 1.5px;
                    border-bottom: none;
                }

                p {
                    margin: 0;

                    &.title {
                        color: #676767
                    }

                    &.score {
                        text-align: center;
                    }
                }
            }

            > li:last-child {
                text-align: center;
                display: inline-block;
                border-bottom: none;
                border-right: none;
                width: 100%;
                @media (min-width: 768px) {
                    width: auto;
                    float: right;
                }

                div {
                    margin: 0 auto;
                }
            }

            ::v-deep .dropdown-menu-right {
                @media (max-width: 767px) {
                    left: 5em !important;
                }
            }


        }

    }
</style>


<script>
  import apiMixin from "../../utils/api"
  import datesMixin from "../../utils/dates"
  import LoadingWrapper from "../navigation/LoadingWrapper"
  import Footer from "../navigation/Footer"
  import NavBar from "../navigation/Navbar"
  import Errors from "../errors"

  export default {
    name: 'SiteList',
    components: {Errors, Footer, NavBar, LoadingWrapper},
    mixins: [apiMixin, datesMixin],
    data() {
      return {
        errors: [],
        items: [],
        fields: ['name', 'evaluations', 'summary']
      }
    },
    methods: {
      load() {
        this.withLoading(async () => {
          try {
            this.items = await this.get('/api/sites/')
          } catch (e) {
            this.catchApiError(e)
          }
          if (this.items.length < 1) {
            this.$router.push({name: 'site.create'})
          }
        })
      },
      evaluate($event, item) {
        if (item.pending_evaluation_id == null && item.latest_evaluation_score != null) {
            return this.goTo($event, item, 'evaluation.start')
        }
        return this.goTo($event, item, 'evaluation.create')
      },
      resolve(item, page, extraParams = {}) {
        return this.$router.resolve({name: page, params: {siteId: item.id, ...extraParams}}).route.path
      },
      goTo: function (e, item, page, extraParams = {}) {
        e.preventDefault()
        this.$router.push({name: page, params: {siteId: item.id, ...extraParams}})
      },
      async deleteSite(siteId) {
        this.loading = true
        try {
          await this.delete(`/api/sites/${siteId}/`)
          this.items = this.items.filter(site => site.id !== siteId)
        } catch (err) {
          this.catchApiError(err, false)
        } finally {
          this.loading = false
          this.$bvModal.hide(`coming-site-delete-${siteId}`)
        }
      }
    }
  }
</script>
